import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

function PdpSharedDetailStoneCut({ item }) {
    return (
        <PdpSharedDetailAttributeLink
            dataTn="pdp-spec-stone-cut"
            item={item}
            attributes={get(item, 'attributes.stoneCut')}
        />
    );
}

PdpSharedDetailStoneCut.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailStoneCut, {
    item: graphql`
        fragment PdpSharedDetailStoneCut_item on Item {
            ...PdpSharedDetailAttributeLink_item
            attributes {
                stoneCut {
                    ...PdpSharedDetailAttributeLink_attributes
                }
            }
        }
    `,
});
